<template>
    <div class="jumio-result-modal">
        <img :src="imageSrc"
            class="jumio-result-modal__image"
            alt="Result icon"
        >
        <div class="jumio-result-modal__wrapper">
            <template v-if="success">
                <p class="jumio-result-modal__text">
                    {{ $t('kycManualReview.title') }}
                </p>
                <p class="jumio-result-modal__text">
                    <span>{{ $t('kycManualReview.description1') }}</span>
                    <span class="jumio-result-modal__bold">{{ $t('kycManualReview.description2') }}</span>
                    <span>{{ $t('kycManualReview.description3') }}</span>
                </p>
                <p class="jumio-result-modal__text jumio-result-modal__bold">
                    {{ $t('kycManualReview.subMessage') }}
                </p>
            </template>
            <p v-else
                class="jumio-result-modal__text"
            >
                {{ $t('kycAutomatedFlow.onCancellation') }}
            </p>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        success: {
            type: Boolean,
            default: true,
        },
        onClose: {
            type: Function,
            default: () => ({}),
        },
    },
    computed: {
        imageSrc() {
            return this.success ? require('@/assets/info.webp') : require('@/assets/oopps.webp');
        },
    },
    destroyed() {
        this.onClose();
    },
};
</script>

<style lang="scss" scoped>
.jumio-result-modal {
    &__wrapper {
        padding-top: 2.6rem;
        background: $white-color;
        text-align: center;
        color: $cyprus-color;
        font-size: 1.5rem;
        line-height: 2rem;

        @include max-width(sm) {
            padding: 2rem 0;
        }
    }

    &__image {
        display: block;
        margin: 0 auto;
        object-fit: contain;
        max-width: 13.6rem;
        min-height: 12rem;

        @include min-width(md) {
            max-width: 15.6rem;
            min-height: 16rem;
        }

        @include max-width(sm) {
            max-width: 9.6rem;
            min-height: 11rem;
        }
    }

    &__text {
        font-size: 1.4rem;
        text-align: center;
        color: $black-color;
    }

    &__bold {
        font-weight: bold;
    }
}
</style>